//settings
import React, { useState } from "react";

//styles
import StylesHome from "./home.module.scss";

//icons
import { 
        FaPhoneAlt, FaEnvelope, FaFacebook, FaLinkedin
    } from "react-icons/fa";


//assets
import myPhoto from "../../assets/general_images/smiling_photo.png";
	
const HomeView: React.FC = () => {

    const [downloadState, setDownloadState] = useState(false);

    const contactMe = (contactNumber: number) => {
        switch (contactNumber) {
            case 1:
                window.location.href = "tel:+524381173272";
              break;
            case 2:
                window.location.href = "mailto:samuelgonzalezlunar@gmail.com";
              break;
            case 3:
                window.open("https://www.linkedin.com/in/samuel-gonzález-lunar-1390aa227", "_blank");
                break;
            default:
                window.open("https://www.facebook.com/samuel.gonzaleslunar?mibextid=ZbWKwL", "_blank");
                break;
          }
    };

    const downloadCV = () => {
        let downloadActive = true;
        if (downloadState) {
            const confirmed = window.confirm("¿Está seguro de descargar nuevamente mi CV?");
            if (!confirmed) {
                downloadActive = false;
            }
        }
        if (downloadActive) {
            const link = document.createElement("a");
            link.href = "/files/my-cv.pdf";
            link.download = "Samuel Gonzalez Lunar CV.pdf";
            link.click();
            setDownloadState(true);
        }
    };

    return (
        <>
            <div className={[StylesHome.__main_home_container].join(' ')}>
                <div className={[StylesHome.__text_div].join(' ')}>
                    <div className={[StylesHome.__data_info].join(' ')}>
                        <div className={[StylesHome.__main_text_title].join(' ')}>
                            <div className={[StylesHome.__hello].join(' ')}>
                                Hola
                            </div>
                            <div className={[StylesHome.__welcome].join(' ')}>
                                Bienvenido
                            </div>
                            <div className={[StylesHome.__presentation].join(' ')}>
                                Mi nombre es
                            </div>
                            <div className={[StylesHome.__name].join(' ')}>
                                Samuel González Lunar
                            </div>
                        </div>
                        <div className={[StylesHome.__job_title].join(' ')}>
                            <div>Desarrollador fullstack</div>
                        </div>
                        <div className={[StylesHome.__description_div].join(' ')}>
                            <span>
                                Soy un desarrollador de software con 3 años de experiencia en el área.
                                Mi mayor habilidad ha sido el aprendizaje rápido, lo que me ha permitido aprender 
                                nuevas tecnologías de una manera ágil y eficaz
                            </span>
                        </div>
                        <div className={[StylesHome.__download_button].join(' ')}>
                            <button onClick={()=>downloadCV()}>Descargar CV</button>
                        </div>
                        <div className={[StylesHome.__contacts].join(' ')}>
                            <div className={[StylesHome.__social_media].join(' ')}>
                                <div onClick={()=>contactMe(1)} className={[StylesHome.__link].join(' ')}><FaPhoneAlt /></div>
                                <div onClick={()=>contactMe(2)} className={[StylesHome.__link].join(' ')}><FaEnvelope /></div>
                                <div onClick={()=>contactMe(3)} className={[StylesHome.__link].join(' ')}><FaLinkedin /></div>
                                <div onClick={()=>contactMe(4)} className={[StylesHome.__link].join(' ')}><FaFacebook /></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={[StylesHome.__my_photo_div].join(' ')}>
                    <img src={myPhoto} alt="myPhoto" />
                </div>
            </div>
        </>
    );
}

export default HomeView;